import * as ReportsActionCreator from "./ReportsActionCreator";

export function defaultReportsProjects() {
    return {
        loading: false,
        response: null,
        error: null,
        userId:"",
        startDate:"",
        endDate:"",
        page:0,
        size:10
    };
}

export const ReportsReducer = (state, action) => {
if (
    !state ||
    action.type === ReportsActionCreator.REPORTS_ACTION.RESET_REPORTS_PROJECTS_STATE
) {
    return { ...state, ...defaultReportsProjects()};
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.REQUEST_REPORTS_PROJECTS) {
    return { ...state, loading: true,  
        userId:action.data.userId, 
        fromDate: action.data.startDate, 
        toDate: action.data.endDate,
        page:action.data.page,
        size:action.data.size
    }; 
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.RESPONSE_REPORTS_PROJECTS) {
    return { ...state, response:action.data , loading: false}
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.ERROR_REPORTS_PROJECTS) {
    return { ...state, error:action.data , loading: false}
}

    return state; 
}


export function defaultGenerateReport() {
    return {
        loading: false,
        response: null,
        error: null,
   };
}

export const GenerateReportReducer = (state, action) => {
if (
    !state ||
    action.type === ReportsActionCreator.REPORTS_ACTION.RESET_GENERATE_REPORT_STATE) {
    return { ...state, ...defaultGenerateReport()};
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.REQUEST_GENERATE_REPORT) {
    return { ...state, loading: true};
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.RESPONSE_GENERATE_REPORT) {
    return { ...state, response:action.data , loading: false}
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.ERROR_GENERATE_REPORT) {
    return { ...state, error:action.data , loading: false}
}
    return state; 
}

export function defaultBudgetReports() {
    return {
        loading: false,
        response: null,
        error: null,
        project:"",
        page:0,
        size:10
    };
}

export const BudgetReportReducer = (state, action) => {
if (
    !state ||
    action.type === ReportsActionCreator.REPORTS_ACTION.RESET_BUDGET_REPORTS_STATE
) {
    return { ...state, ...defaultBudgetReports()};
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.REQUEST_BUDGET_REPORTS) {
    return { ...state, loading: true, project: action.data.project, page: action.data.page, size: action.data.size};
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.RESPONSE_BUDGET_REPORTS) {
    return { ...state, response:action.data , loading: false}
}

if ( action.type === ReportsActionCreator.REPORTS_ACTION.ERROR_BUDGET_REPORTS) {
    return { ...state, error:action.data , loading: false}
}
    return state; 
}
